import { defineStore } from 'pinia';
import OrderService from 'src/core/services/OrderService';

export const OrderStore = defineStore('OrderStore', {
  state: () => ({
    orderList: {
      list: [],
      count: 0,
    },
  }),
  actions: {
    async userOrderList(listInfo) {
      const { status, message, data } = await OrderService.orderList(listInfo);
      if (status._200_) {
        this.orderList.list = data.list;
      }

      return { status, message, data };
    },
  },
});
